import { render, staticRenderFns } from "./new.registration-forms.page.vue?vue&type=template&id=e25da12c&"
import script from "./new.registration-forms.page.vue?vue&type=script&lang=js&"
export * from "./new.registration-forms.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports